<template>
  <div class="form-elements va-row">

      <div class="flex sm4 xs12 offset--sm4">
        <va-card :title="$t('Create Watched mention')">

          <loading :active.sync="loading" :is-full-page="false"></loading>

          <form @submit.prevent="onsubmit()" class="text-right">
                
                <va-input
                  name = "Screen name"
                  v-model="payload.screen_name"
                  v-validate="{required: true}"
                  placeholder="Account screen name"
                  :errorMessages="[screen_name_err]"
                  :error="screen_name_has_err"
                />
                
                <va-button color="success" :to="{ name: 'WatchedMentionList' }" >Back</va-button>
                <va-button color="info" type="submit">Create watched mention</va-button>
              
          </form>
        </va-card>
      </div>

  </div>
</template>

<script>

import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Validation from '@/mixins/ValidationMixin';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'mention-form',
  mixins: [Validation.Validation],
  components:{Loading},
  data () {
    return {
      loading: false,
      payload: {
        screen_name:""
      }
    }
  },

  computed: {

    ...Validation.mapValidationKeys([
        "screen_name"
    ]),

  },

  methods: {

     ...mapActions({
      save: 'createMention'
    }),

    onsubmit () {

      this.loading  = true;
      this.save( this.payload ).then( response => {
          this.$router.push({ name: 'WatchedMentionList' })
      }).catch( exeption => (this.valErr = exeption,this.loading = false ));


    }
  }
}
</script>

<style>
  .row.row-inside {
    max-width: none;
  }
</style>
